import { Routes, Route, Navigate } from "react-router-dom";
import React, { useState } from 'react';
import { PlayerContext } from '../utils/contexts/PlayerContext';
import Select from '../pages/Player/select'
import Panel from '../pages/Player/panel'
import { Guild } from '../utils/types';

function Player({ user }: any) {
  const [playerGuild, setPlayerGuild] = useState<Guild>();
  const updatePlayerGuild = (playerGuild: Guild) => setPlayerGuild(playerGuild);

  // console.log(playerGuild)

  return (
    <PlayerContext.Provider value={{ playerGuild, updatePlayerGuild }}>
      <Routes>
        <Route path="/player" element={<Navigate replace to="/player/select" />} />
        <Route path="/player/select" element={<Select />} />
        <Route path="/player/panel" element={playerGuild ? <Panel user={user} /> : <Navigate replace to="/player/select" />} />
      </Routes>
    </PlayerContext.Provider>
  )
}

export default Player